'use client';

import { useTranslation } from 'next-i18next';

export const TagCloud = ({ jobInterests }: { jobInterests?: ApiSchema<'JobInterest'>[] }) => {
  const { t } = useTranslation('common');

  // The whole section (title + content) only renders when the resume's
  // jobInterests contain at least one non-empty title.
  const items = (jobInterests ?? []).filter(
    (item): item is ApiSchema<'JobInterest'> & { title: string } => (
      typeof item.title === 'string' && item.title.trim().length > 0
    ),
  );

  if (!items.length) return null;

  return (
    // pt-4 instead of the usual pt-2: the ProfileAbout section above ends with
    // an unmargined text block, so this section provides the full gap itself.
    <section className="pt-4">
      <h6 className="mb-4 mr-2 border-b border-dotted pb-4 text-lg font-semibold">
        {t('cv.section.label.tagCloud')}
      </h6>
      <p className="mb-4 text-sm leading-relaxed text-ink">
        {items.map((item) => item.title).join(' · ')}
      </p>
    </section>
  );
};
